export { ProductIcon } from "./product-icon";
